import { createPatient, CreatePatientData } from '../../api/healthcare';
import { markPatientSynced } from '../db';
import { WriteHandler } from './types';

/**
 * Replays an offline-created patient. `payload` is the exact
 * CreatePatientData object built at enqueue time, including the
 * client_uuid the patient was cached under locally -- the backend's
 * FHIRPatientRecordViewSet.create() treats a repeat of the same
 * client_uuid as a no-op (see backend/apps/healthcare/views.py), so this
 * is safe to retry after a crash mid-sync.
 */
export const createPatientHandler: WriteHandler = async (row) => {
  const payload = JSON.parse(row.payload) as CreatePatientData;
  await createPatient(payload);
  if (payload.client_uuid) {
    await markPatientSynced(payload.client_uuid);
  }
};
